
import autobind from 'class-autobind';
import BaseComponent from '../App/base';
import * as actions from '../../actions/SettingsActions';
import SettingsView from './view';
import API from '../../api';


let pusher = false;


export default class Settings extends BaseComponent {

  constructor(selector, store) {

    super(selector, store, 'settings');

    window.settingsActions = actions;

    const path = window.location.pathname;
    if (path === '/settings' || path === '/settings/') {
      highlights.disable();
      history.pushState({}, 'CLARO', '/app');
      scrollPosition = document.documentElement.scrollTo;
      $('body').addClass('settings');
      store.dispatch(actions.showSettings());
    }
    if (path === '/payment' || path === '/payment/') {
      highlights.disable();
      history.pushState({}, 'CLARO', '/app');
      scrollPosition = document.documentElement.scrollTo;
      $('body').addClass('settings');
      store.dispatch(actions.redirectToPayment());
    }

    autobind(this);

    this.failedAttemps = 0;

    this.getUserdata();
    this.initializeNavigation();

    const self = this;

    setInterval(function () {
      self.getUserdata();
   }, 1000*60*60); //refresh every hour

  }


  initializePusher() {

  }

  getUserdata() {

    const self = this;
    API.userdata()
      .then((resp) => {

        if (
          typeof resp !== "undefined" &&
          typeof resp.logout !== "undefined" &&
          resp.logout === true
        ){
          setTimeout(function () {
            console.log('redirect to login (settings)');
            window.location.href = "/login";
          }, 200);
          localStorage.removeItem("JWTtoken");
        }

        window.store.dispatch(window.settingsActions.setUserdata(resp));
        this.failedAttempts = 0;
        const data = window.config.getUserdata();

        const pastDate = moment(data.pastDateLimit).startOf('day');
        const userDate = moment().startOf('day');
        const duration = moment.duration(userDate.diff(pastDate));
        const days = duration.asDays();

        pastDateLimit = -days - 1;

        // soundEnabled = data.sound;
        boxOpenedOnLoad = data.box;

        if (window.config.isSound()) {
          $('#sound #on').hide();
          $('#sound #off').show();
        } else {
          $('#sound #on').show();
          $('#sound #off').hide();
        }

        if (!data.hasSubscription) {
          if (!window.location.href.match(/nosubscription/)) {

            // window.location.href = "/nosubscription";
          }
        }
        
        if (data.subscription_status == 'trialing') {
            window.store.dispatch(window.trialActions.showTrialDays());
            const daysLeft = moment(data.stripeInfoPeriod.slice(-10)).diff(moment(), 'days')
            window.store.dispatch(window.trialActions.setDaysLeft(daysLeft+1))
        }

        if (data.usePusher && !pusher) {
          pusher = new Pusher(data.pusherKey, {
            cluster: data.pusherCluster,
            forceTLS: true,
          });

          const channel = pusher.subscribe(data.pusherChannel);
          channel.bind('tasklist_updated', (data) => {
            if (activeEdit) {
              cancelEdit($('li.editing textarea'));
            }
            optionsMenu.hide();

            for (i = 0; i < data.days.length; i++) {


              if (data.days[i] == 'box') {
                var boxNewId = new Array();
                const boxNewLi = $('#box li.box-new');
                if (boxNewLi.length > 0) {
                  for (j = 0; j < boxNewLi.length; j++) {
                    boxNewId[j] = $(boxNewLi[j]).attr('id');

                  }
                }
              }


              if ($(`.column[rel=${data.days[i]}]`).length) {
                tasks.getDay(moment().format('YYYY-MM-DD'), data.days[i], true);
              } else if (columnCache[data.days[i]]) {
                updateCache(data.days[i]);
              }
              if (data.days[i] == 'box') {
                var boxNew = data.method == 'add';
                var boxIds = data.tasks;
                setTimeout(() => {
                  updateBoxIcon(boxNew);
                  if (boxNew) {
                    for (let j = 0; j < boxIds.length; j++) {
                      $(`#${boxIds[j].realId}`).addClass('box-new');
                    }
                    for (let j = 0; j < boxNewId.length; j++) {
                      $(`#${boxNewId[j]}`).addClass('box-new');
                    }
                    if ($('body').hasClass('box-opened')) {
                      setTimeout(() => {
                        $('li.box-new').removeClass('box-new');

                      }, 2400);
                    }
                  }
                }, 400);
              }
            }
          });

          pusher.connection.bind('connected', () => {

            pusherSocketId = pusher.connection.socket_id;
          });
        }

        if (!data.demo) {
          initAWSM(data);
        }
      })

      .catch((e) => {
        if (this.failedAttemps++ < 10){
          /* retry after 10 sec */
          setTimeout(function () {
            self.getUserdata();
          }, 1000*10);
        }
        else{
          /* log out after 10 failed attempts */
          setTimeout(function () {
            console.log('redirect to login (settings)');
            window.location.href = "/login";
          }, 200);
          localStorage.removeItem("JWTtoken");
        }
      });
  }

  initializeNavigation() {

    $('#sound').click(() => {
      if (window.config.isSound()) {
        $('#sound #on').show();
        $('#sound #off').hide();
      } else {
        $('#sound #on').hide();
        $('#sound #off').show();

      }

      window.config.toggleSound();
    });

    $('#nav-close a').click(() => {
      $('body').removeClass('settings');
      // $('#nav-overlay').hide();
      window.store.dispatch(actions.hideSettings());
      return false;
    });
  }

  updateForms() {
    $("#user-form").submit(function () {
      let error = false;

      if ($("#email").val().length === 0) {
        $("#email")
          .parent()
          .find(".help-block")
          .html("The email field is required");
        error = true;
      } else if (
        !$("#email")
          .val()
          .match(
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i
          )
      ) {
        error = true;
        $("#email")
          .parent()
          .find(".help-block")
          .html("The email must be a valid email address");
      } else {
        $("#email").parent().find(".help-block").html("");
      }

      if (
        $("#password").val().length !== 0 &&
        $("#password").val().length < 8
      ) {
        $("#password")
          .parent()
          .find(".help-block")
          .html("The password must be at least 8 characters");
        error = true;
      } else {
        $("#password").parent().find(".help-block").html("");

      }

      if (error) {
        return false;
      }

      $("button.btn", this).addClass("submited");

      API.account({
        name: $("#name").val(),
        email: $("#email").val(),
        password: $("#password").val(),
        invoice_data: $("#invoice_data").val(),
      }).then((data) => {
        $("button.btn").removeClass("submited");
        if (typeof data.success != "undefined") {
          $("#user-form-msg").html(data.success);

          API.userdata();
        } else {
          $("#user-form-msg").html("");
          if (typeof data.name != "undefined") {
            $("#name").parent().find(".help-block").html(data.name[0]);
          }
          if (typeof data.email != "undefined") {
            $("#email").parent().find(".help-block").html(data.email[0]);
          }
          if (typeof data.password != "undefined") {
            $("#password").parent().find(".help-block").html(data.password[0]);
          }
        }
      });

      return false;
    });

    $("#payment-form")
      .off()
      .submit(function () {
        console.log("initializeStripeForm");


        const { settings } = window.store.getState();
        const { paymentSessionId } = settings;

        const { userdata } = settings


        var $form = $(this);

        if (paymentSessionId) {
          stripe
            .redirectToCheckout({
              sessionId: paymentSessionId,
            })
            .then(function (result) {
              $form.find("button").removeAttr("disabled");
            });
        } else {
          console.error("Missing session id");

        if(userdata.hasCard) {

          API.stripe_session().then((data) => {
            window.store.dispatch(
              window.settingsActions.setPaymentSessionId(data.session_id)
            );
            $("#payment-form").submit();
          });
        }
        else
        {
          API.renew_session().then((data) => {
            window.store.dispatch(
              window.settingsActions.setPaymentSessionId(data.session_id)
            );
            $("#payment-form").submit();
          });
        }
        }
        return false;
      });


  }

  render() {
    console.log("render");

    const { settings } = store.getState();
    const { settingsActive, paymentSessionId, directPayment } = settings;
    console.log(paymentSessionId);

    if(directPayment){
      $(this.$selector).find("#nav-content").html(SettingsView);
      this.updateForms();
      $('#payment-form').submit();
    }
    else if (settingsActive) {
      $("#nav-overlay").show();
      $(this.$selector).find("#nav-content").html(SettingsView);
      this.updateForms();
    } else {
      $("#nav-overlay").hide();
      $(this.$selector).find("#nav-content").html("");
    }



  }
}
